export const validCertificates = (productList) => {
  const filteredEmptyCertificates = productList?.filter(
    (product) => product.certificate
  );

  const certificateList = filteredEmptyCertificates?.map((product) => {
    const {
      digitalAssetId,
      fileSize,
      fileType,
      linkUrl,
      pdfPreview,
      status,
      thumb,
      ...rest
    } = product?.certificate || {};

    return {
      ...rest,
    };
  });

  return { documents: certificateList };
};
